import { GleapManager } from './gleapManager';
import { MixpanelManager } from './mixpanelManager';
import { MockupsApi } from '@/domain/mockups/mockupsApi';
import type { StatsResponse } from '@/domain/mockups/mockupsDto';

export class TrackingManager {
  private static statsLoaded = false;
  private static statsLoadingPromise: Promise<void> | undefined;

  public static pushTrackEvent(eventName: string, payload?: any, options?: any) {
    const trackMixpanel = !options || (options.trackMixpanel && options.trackMixpanel === true);
    const trackGleap = !options || (options.trackGleap && options.trackGleap === true);

    if (trackMixpanel) {
      MixpanelManager.pushTrackEvent(eventName, payload);
    }
    if (trackGleap) {
      GleapManager.pushTrackEvent(eventName, payload);
    }
  }

  public static async loadUserStatsOnce(): Promise<void> {
    if (this.statsLoaded) return;
    if (this.statsLoadingPromise) return this.statsLoadingPromise;

    this.statsLoadingPromise = (async () => {
      try {
        const stats: StatsResponse | undefined = await MockupsApi.getStats();
        if (!stats) return;

        const mapped = {
          products_active: stats.mockups?.active ?? 0,
          products_deleted: stats.mockups?.deleted ?? 0,
          collections_active: stats.collections?.active ?? 0,
          collections_deleted: stats.collections?.deleted ?? 0,
        };

        MixpanelManager.setUserStats(mapped);
        GleapManager.setUserStats(mapped);
        this.statsLoaded = true;
      } catch (e) {
        // fail silently
      }
    })().finally(() => {
      this.statsLoadingPromise = undefined;
    });

    return this.statsLoadingPromise;
  }
}
